module.exports = __webpack_public_path__ + "img/sup_cardsetting_ewalleti3.c92c7154.jpg";